import { useNavigate } from 'react-router-dom'
import { useEffect, useRef } from 'react'

function BarraAggiungiEvento() {
    const navigate = useNavigate()
    const bannerCreaEvento = useRef()
    const brnInsEvento = useRef()

    useEffect(() => {
        function lampeggiaSfondo() {
            if (brnInsEvento.current.style.backgroundColor === 'mediumblue') {
                brnInsEvento.current.style.color = 'black'
                brnInsEvento.current.style.backgroundColor = 'gold'
            }
            else {
                brnInsEvento.current.style.backgroundColor = 'mediumblue'
                brnInsEvento.current.style.color = 'whitesmoke'
            }
        }
        const intervallo = setInterval(lampeggiaSfondo, 1000)
        return () => clearInterval(intervallo)
    }, [])
    return (<>
        <div style={{ margin: '4em 0 4em 0' }}>
            <div className='text-center'>
                <button ref={brnInsEvento} style={{ width: '80%', backgroundColor: 'red', padding: '10px 5px', fontWeight: '700', fontSize: 'large' }}
                    onClick={() => { navigate('/addEvento') }}
                >📆 AGGIUNGI IL TUO EVENTO
                </button>
            </div>
        </div>
    </>)

}
export default BarraAggiungiEvento